import React, { useEffect } from 'react';
import { spotify_redirect_uri, local_spotify_redirect_uri } from '../spotify/spotify';
import queryString from "querystring";
import { CLIENT_ID } from '../config';
import { useNavigate } from 'react-router';

const generateRandomString = (length: number): string => 'state';

//const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
//console.log(CLIENT_ID);

const Home: React.FC = () => {
    const navigate = useNavigate();
    let state = generateRandomString(16);
    let scope = 'user-read-private user-read-email user-library-read user-library-modify user-read-recently-played';
    const local = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

  useEffect(() => {
    if (window.location.pathname.includes('callback') || window.location.href.includes('callback') || window.location.href.includes('code=')) {
        const { code, state } = queryString.parse(window.location.search.substring(1));
        if (code) {
          window.history.replaceState({}, document.title, "/");
          navigate(`/callback?code=${code}&state=${state}`);
        }
    }
  }, []);

  return (
    <div className="column-centered py-10">
      <p className='text-2xl my-5'>Song A Day</p>
      <a href={`https://accounts.spotify.com/authorize?client_id=${CLIENT_ID}&redirect_uri=${local ? local_spotify_redirect_uri : spotify_redirect_uri}&scope=${scope}&state=${state}&response_type=code`}>Authorize Spotify Account</a>
    </div>
  );
}

export default Home;
